<template>
  <div class="home">

    <div class="banner">
      <div class="b-info text-white">
        <div class="title">
          <h1>不木钱包</h1>
          <p>一款有温度的发薪工具</p>
          <img src="../../assets/font.png" alt="不木钱包" />
        </div>
        
        <div class="avader">
          <img src="../../assets/banner-money.png" alt="不木钱包" />
        </div>
      </div>
      <div class="b-list">
        <div class="b-item animated anitr-1 slideInUp">
          <img src="../../assets/banner-1.png" alt="不木钱包" />
          <h1>资金安全</h1>
          <p>银行支付通道、资金明细可视</p>
          <p>身份实名认证、实时通知反馈</p>
        </div>
        <div class="b-item animated anitr-2 slideInUp">
          <img src="../../assets/banner-2.png" alt="不木钱包" />
          <h1>数据安全</h1>
          <p>数据加密传输、前端显示脱敏</p>
          <p>操作权限分级、信息多重校验</p>
        </div>
        <div class="b-item animated anitr-3 slideInUp">
          <img src="../../assets/banner-3.png" alt="不木钱包" />
          <h1>管理省心</h1>
          <p>无纸化办公、无需额外办银行卡</p>
          <p>无需支付手续费、无繁琐流程</p>
        </div>
        <div class="b-item animated anitr-4 slideInUp">
          <img src="../../assets/banner-4.png" alt="不木钱包" />
          <h1>使用放心</h1>
          <p>操作简单、体验友好</p>
          <p>7*24小时客服在线</p>
        </div>
      </div>

      <div class="n-title">
        <h1>我们能为你做些什么</h1>
      </div>
    </div>

    <div class="dowhat" :class="{'anitr': this.activeClass('dowhat') }" v-scrollWatch="{...watchOptions, name: 'dowhat'}">
      <div class="select">
        <div class="options" :class="{'active': selectOption == 1}" @click="changeOption(1)">企业发薪</div>
        <div class="options" :class="{'active': selectOption == 2}" @click="changeOption(2)">工资提现</div>
        <div class="options" :class="{'active': selectOption == 3}" @click="changeOption(3)">工资预支</div>
        <div class="options" :class="{'active': selectOption == 4}" @click="changeOption(4)">电子工资单</div>
        <div class="options" :class="{'active': selectOption == 5}" @click="changeOption(5)">个税计算</div>
        <div class="options" :class="{'active': selectOption == 6}" @click="changeOption(6)">电子合同</div>
      </div>
      <div class="s-list">
        <div class="s-item" v-if="selectOption == 1">
          <div class="avader">
            <img src="../../assets/options-1.png" alt="不木钱包" />
          </div>
          <div class="text">
            <h1>企业发薪</h1>
            <p>工资发放即时到账</p>
            <p>发薪明细一目了然</p>
            <p>支持多种发薪方式（日/周/年薪）</p>
          </div>
        </div>
        <div class="s-item" v-if="selectOption == 2">
          <div class="avader">
            <img src="../../assets/options-2.png" alt="不木钱包" />
          </div>
          <div class="text">
            <h1>员工提现工资</h1>
            <p>可实时开户，无需办理银行卡</p>
            <p>可随时提现，无任何手续费</p>
            <p>工资秒到账，无时间延迟</p>
          </div>
        </div>
        <div class="s-item" v-if="selectOption == 3">
          <div class="avader">
            <img src="../../assets/options-3.png" alt="不木钱包" />
          </div>
          <div class="text">
            <h1>员工预支工资</h1>
            <p>根据工资额度授信</p>
            <p>员工提交预支薪资申请</p>
            <p>不木钱包审核并垫资放款</p>
            <!-- <p>发薪日不木钱包自动还款</p> -->
          </div>
        </div>
        <div class="s-item" v-if="selectOption == 4">
          <div class="avader">
            <img src="../../assets/options-4.png" alt="不木钱包" />
          </div>
          <div class="text">
            <h1>电子工资单</h1>
            <p>企业一键发送</p>
            <p>员工一键查询</p>
          </div>
        </div>
        <div class="s-item" v-if="selectOption == 5">
          <div class="avader">
            <img src="../../assets/options-5.png" alt="不木钱包" />
          </div>
          <div class="text">
            <h1>个税计算</h1>
            <p>对接金三系统</p>
            <p>批量计算员工个税</p>
          </div>
        </div>
        <div class="s-item" v-if="selectOption == 6">
          <div class="avader">
            <img src="../../assets/options-6.png" alt="不木钱包" />
          </div>
          <div class="text">
            <h1>电子合同</h1>
            <p>员工在线身份认证</p>
            <p>HR在线管理合同</p>
            <p>合同线上签署成功</p>
          </div>
        </div>

      </div>
    </div>

    <div class="flow" :class="{'anitr': this.activeClass('flow') }" v-scrollWatch="{...watchOptions, name: 'flow'}">
      <div class="title">
        <h1>极简发薪流程，无需银行卡</h1>
      </div>
      <div class="avader imageContent">
        <img src="../../assets/flow.png" alt="不木钱包" />
        <span class="textContent">不木钱包</span>
      </div>
      <p>注：企业通过不木钱包使用自己的银行账户进行发薪，不木钱包提供与银行系统的技术开发与支持，实际资金由银行与企业/工厂进行结算</p>
    </div>

    <!-- <div class="concat">
      <div class="title">
        <h2>联系我们</h2>
      </div>
      <div class="input">
        <input v-model="form.name" :class="{'error-tip': errorClass.name}" type="text" placeholder="姓名" />
        <input v-model="form.tel" :class="{'error-tip': errorClass.tel}" type="text" placeholder="电话" />
        <input v-model="form.company" :class="{'error-tip': errorClass.company}" type="text" placeholder="企业名称" />
      </div>
      <div class="textarea">
        <textarea v-model="form.message" :class="{'error-tip': errorClass.message}" name="" cols="30" placeholder="留言"></textarea>
      </div>
      <div class="btn">
        <button @click="handleSumbit">
          <span>提交</span>
        </button>
      </div>
    </div> -->

  </div>
</template>

<script>
import _ from 'lodash';
import store from '../../store/index'
import { getProducts } from '../../utils/apis';
import scrollWatch from "vue-scrollwatch";

export default {
  name: 'home',
  components: { },
  data: function(){
    return{
      menuType: 1,
      products: [],
      activeMenus: [],
      selectOption: 1,
       form: {
        name: "",
        tel: "",
        company: "",
        message: ""
      },
      errorClass: {
        name: false,
        tel: false,
        company: false,
        message: false
      },
      watchOptions: {
        name:'numbers',
        offset: 500,
        callback: this.spyDomChange.bind(this)
      }
    }
  },
  computed: {
    
  },
  mounted() {
    this.getProducts();
  },
  methods: {
    activeClass(name){
      return this.activeMenus.indexOf(name) >= 0;
    },
    spyDomChange(node) {
      let menus = this.activeMenus;
      if(menus.indexOf(node.name) < 0){
        menus.push(node.name);
        this.activeMenus = menus;
      }
    },
    // 校验是否电话号码
    IsPhoneNumber(phoneNumber) {
      var reg = /^((0\d{2,3}-\d{7,8})|(1[3584]\d{9}))$/;
      return reg.test(phoneNumber);
    },
    // 提交表单
    handleSumbit() {
      this.errorClass.name = this.form.name == "" ? true : false;
      this.errorClass.tel = !this.IsPhoneNumber(this.form.tel);
      this.errorClass.company = this.form.company == "" ? true : false;
      let validateError = Object.entries(this.errorClass).some(item => item[1]);
      if (validateError) {
        return false;
      }
      alert("登录成功！");
      console.log(" result: ", this.form);
    },
    getProducts(){
      getProducts().then((res) =>{
        if(res.data.code == 200){
          this.products = res.data.list;
        }
      })
    },
    changeOption(selectOption){
      this.selectOption = selectOption;
    }
    
  }
}
</script>
<style lang="scss" scoped>
    .home{
      width: 100%;
      .error-tip {
        border: 1px solid #f70d0d !important;
      }
      .banner{
        width: 100%;
        height: 1225px;
        background: url(../../assets/banner.jpg) no-repeat;
        background-size: cover;
        background-position: 50% 50%;
        background-origin: 0 0;
        overflow: hidden;
        
        .b-info{
          width: 1200px;
          margin:  0 auto;
          margin-top: 170px;
          text-align: left;
          display: flex;
          padding-left: 100px;
          
          .title{
            position: relative;
            
            h1{
              font-size: 52px;
              font-weight: bold;
            }
            p{
              font-size: 38px;
              font-weight: 500;
              color: #fff;
            }
            img{
              width: 278px;
              margin-top: 24px;
              margin-left: 0;
            }
          }
          img{
            width: 456px;
            margin-left: 100px;
          }
        }
        .b-list{
          width: 1200px;
          margin:  0 auto;
          margin-top: 60px;
          display: flex;
          justify-content: space-between;

          .b-item{
            width:260px;
            background:rgba(255,255,255,1);
            box-shadow:0px 0px 20px 5px rgba(49,62,72,0.04);
            border-radius:8px;
            padding: 34px 30px;
            img{
              width: 46px;
            }
            h1{
              font-size: 16px;
              color: #333;
              font-weight: 400;
              line-height: 22px;
              margin-top: 20px;
              margin-bottom: 10px;
            }
            p{
              font-size: 12px;
              color: #888;
              line-height: 18px;
              font-weight: 400;
            }
          }
        }
        .n-title{
          margin-top: 120px;
          h1{
            font-size: 36px;
            font-weight: 400;
            color: #333;
            text-align: center;
          }
        }
      }
      .dowhat{
        background: url(../../assets/options-bg.png) 60% 60% no-repeat;
        background-size: contain;
        transform: translateY(100px);
        .select{
          width: 710px;
          margin: 0 auto;
          margin-top: 40px;
          display: flex;
          text-align: center;
          border-bottom: 1px solid #E7E7E7;
          justify-content: space-between;
          .options{
            padding: 18px 0;
            font-size: 16px;
            font-weight: 400;
            color: #666;
            display: inline-block;
            cursor: pointer;
            height: 100%;
            &.active{
              position: relative;
              &::after{
                content: ' ';
                position: absolute;
                width: 100%;
                height: 2px;
                border-radius: 2px;
                left: 0;
                right: 0;
                bottom: -2px;
                background: #206EFD;
              }
              color: #206EFD;
            }

          }
        }
        .s-list{
          width: 1200px;
          margin: 0 auto;
          margin-top: 10px;
          margin-bottom: 83px;
          display: flex;
          justify-content: center;
          min-height: 500px;
          .s-item{
            display: flex;
            min-height: 500px;
            .avader{
              width: 500px;
              position: relative;
              img{
                width: 100%;
              }
              
            }
            .text{
              width: 460px;
              padding: 150px 34px;
              h1{
                font-size: 30px;
                font-weight: 600;
                color: #333;
                line-height: 42px;
                margin-bottom: 40px;
                position: relative;
                &::after{
                  content: ' ';
                  position: absolute;
                  left: 0;
                  border-radius: 4px;
                  top: -6px;
                  width:38px;
                  height:4px;
                  background:#206EFD;
                }
              }
              p{
                font-size: 14px;
                color: #666;
                font-weight: 400;
                line-height: 24px;
              }
            }
          }
        }

      }
      .flow{
        margin-top: 40px;
        margin-bottom: 180px;
        transform: translateY(100px);
        .title{
          text-align: center;
          h1{
            font-size: 30px;
            font-weight: 400;
            color: #333;
          }
        }
        .avader{
          text-align: center;
          margin-top: 48px;
          img{
            width: 1010px;
          }
        }
        p{
          font-size: 12px;
          color: #999;
          text-align: center;
          margin-top: 30px;
        }
      }
      .concat{
        width: 1100px;
        margin: 0 auto;
        margin-top: 106px;
        margin-bottom: 100px;
        text-align: center;
        padding: 80px 90px;
        box-shadow:0px 0px 20px 3px rgba(13,37,62,0.05);
        border-radius:22px;
        background: #fff;
        .title{
          h1{
            font-size: 36px;
            font-weight: 400;
            color: #333;
          }
        }
        .input{
          width: 920px;
          margin: 0 auto;
          margin-top: 70px;
          display: flex;
          justify-content: space-between;
          input{
            width:260px;
            height:40px;
            border: none;
            border-bottom:1px solid #E6E6E6;
            &:focus{
              border-bottom: 1px solid #206EFD;
            }
          }
        }
        .textarea{
          margin-top: 40px;
          textarea{
            width: 920px;
            border: none;
            border-bottom:1px solid #E6E6E6;
            &:focus{
              border-bottom: 1px solid #206EFD;
            }
          }
        }
        .btn{
          button{
            width: 167px;
            height: 40px;
            line-height: 40px;
            background: #1e88f5;
            box-shadow: 0px 0px 10px 0px rgba(0, 145, 255, 0.74);
            border-radius: 32px;
            margin-top: 60px;
            border: none;
            color: #fff;
            cursor: pointer;
            &:hover{
              opacity: .9;
            }
          }
        }
      }

      .anitr{
        animation: 1s topcity;
        animation-fill-mode: both;
      }
      .anitr-1 {
        animation-delay: .2s
      }

      .anitr-2 {
        animation-delay: .4s
      }

      .anitr-3 {
        animation-delay: .6s
      }

      .anitr-4 {
        animation-delay: .8s
      }

      .anitr-5 {
        animation-delay: 1s
      }

      .anitr-6 {
        animation-delay: 1.2s
      }

      .anitr-7 {
        animation-delay: 1.4s
      }

      @keyframes topcity{
        from {
          opacity: 0.2;
          transform: translate3d(0, 100px, 0);
        }

        to {
          opacity: 1;
          transform: translate3d(0, 0, 0);
        }
      }
      @keyframes banner{
        0%{ top: 40% }
        100%{ top: 50%; }
      }
    }
    
    .list-enter-active, .list-leave-active {
      transition: all 1s;
    }
    // 设置初始位置
    .list-enter, .list-leave-to {
      opacity: 0;
      transform: translateX(-30px)
      // transform: translateY(30px);
    }
    .list-move {
      transition: transform 1s;
    }
    .imageContent{
      position: relative;
      .textContent{
        position: absolute;
        font-size: 25px;
        font-weight: bold;
        background: #fff;
        bottom: 0;
        /* margin: 0 auto; */
        left: 50%;
        width: 100px;
        margin-left: -48px;
      }
    }
</style>
